import store from '@/store/store'
import { setUser } from '@/store/user'

const decodeBase64Url = (value: string): any => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64 + '='.repeat((4 - base64.length % 4) % 4)
  const bytes = Uint8Array.from(window.atob(padded), (c) => c.charCodeAt(0))
  return JSON.parse(new TextDecoder().decode(bytes))
}

const normalizeSucursales = (value: any): string[] => {
  const list = Array.isArray(value) ? value : (typeof value === 'string' ? [value] : [])
  return list
    .filter((item): item is string => typeof item === 'string')
    .map((item) => item.trim())
    .filter((item) => item !== '')
}

// El ACS de WOM (SAML) devuelve al backoffice con #session=<base64url> cuando la
// aserción es válida, o #error=<código> cuando no. La sesión se consume una sola vez,
// antes del primer render, porque los guards de ruta leen el store en ese momento:
// si esperamos a montar un componente, ya nos mandó a login.
export const consumeSsoSession = (): void => {
  const hash = window.location.hash.replace(/^#/, '')
  if (hash === '') return

  const params = new URLSearchParams(hash)
  const raw = params.get('session')
  const error = params.get('error')

  if (error !== null) {
    console.error('Login SSO rechazado:', error)
  } else if (raw !== null) {
    try {
      const session = decodeBase64Url(raw)
      // `sso: true` marca la sesión como federada. Solo lo usa el guard para el seller
      // ti_wom, donde el ACS todavía no resuelve el usuario en la BD y devuelve id 0.
      // `sucursales` se normaliza siempre a array de strings: el ACS puede omitirlo,
      // mandarlo como string único o con vacíos, y el resto del app lo lee sin chequear.
      store.dispatch(setUser({ ...session, sucursales: normalizeSucursales(session.sucursales), logged: true, sso: true }))
    } catch (err) {
      console.error('No se pudo leer la sesión SSO:', err)
      return
    }
  } else {
    return
  }

  // Fuera el token de la barra de direcciones (y del historial).
  window.history.replaceState(null, '', window.location.pathname + window.location.search)
}
